import styled from 'styled-components';
import {Row} from '../../common/Layouts/Layouts';
import {CheckBox} from '../../common/CheckBox/CheckBox';

export const RoomSelectHeadWrap = styled.div(
  props => `
    position: sticky;
    top: 12.5rem;
    z-index: ${props.theme.misc.zIndex.base};
    width: 100%;
    display: flex;
    align-items: center;
    background-color: ${props.theme.colors.white.bgWhite1};
    height: 4.5rem;
    border-radius: ${props.theme.misc.borderRadius.xxlarge} ${props.theme.misc.borderRadius.xxlarge} 0 0; 
    border-bottom: 1px solid ${props.theme.colors.grey.lightba};
  `
);

export const RoomTypeWrap = styled.div(
  props => `
      width: 42rem;
      display: flex;
      border-right: 1px solid ${props.theme.colors.grey.lightba};
  `
);

export const RoomTypeHeadText = styled.p(
  props => `
      font-size: ${props.theme.font.base};
      color: ${props.theme.colors.grey.base};
      font-weight: ${props.theme.font.fontWeight.bold};  
      padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.large.l20};
      text-transform: ${props.theme.font.textTransform.upper};
  `
);

export const RatePlanWrap = styled.div(
  props => `
      width: 37.8rem;
      display: flex;
      border-right: 1px solid ${props.theme.colors.grey.lightba};
  `
);

export const RoomPricePriceWrap = styled.div(
  props => `
      width: 40rem;
      display: flex;
  `
);

// export const WrapperDiv = styled(Row)(
//   props => `
//   background-color: ${props.theme.colors.blue.bgBlueLight};
//   width: 100%;
//   position: sticky;
//   top: 148px;
//   left: 0;
//   z-index: ${props.theme.misc.zIndex.xxsmall};
//   border-radius:${props.theme.misc.borderRadius.xxxlarge};
//   border-bottom-right-radius:0;
//   border-bottom-left-radius:0;

// `,
// );

// export const TextStylingWrapperSpan = styled(Row)(
//   props => `
//   font-size: ${props.theme.font.large.font16};
//   font-weight: bold;
// `,
// );

// export const ItemWrapperDiv = styled(Row)(
//   props => `
//   // background-color: ${props.theme.colors.blue.bgBlueLight};
//   padding: ${props.theme.spacing.large.l20};
//   width: 25%;
//   border-right: 0.1rem solid ${props.theme.colors.grey.grey15};
//   justify-content: center;
//   flex: 1;
//   &:last-child {
//     border-right: none;
//   }
// `,
// );
